import React from 'react';
import { computed } from 'mobx';

export default class TransferModel {
  id;
  created_at;
  observation_id;
  parameter_id;
  source_table;
  destination_table;
  status;
  date_from;
  date_to;
  date_reached;
  filter_duplicate;
  delete_from_source;
  remark;
  stations;
  parameters;

  store;
  saveHandler;

  constructor(store, transfer) {
    this.store = store;

    this.id = +transfer.id;
    this.created_at = transfer.created_at;
    this.observation_id = transfer.observation_id;
    this.parameter_id = transfer.parameter_id;
    this.source_table = transfer.source_table;
    this.destination_table = transfer.destination_table;
    this.status = transfer.status;
    this.date_from = transfer.date_from;
    this.date_to = transfer.date_to;
    this.date_reached = transfer.date_reached;
    this.filter_duplicate = transfer.filter_duplicate;
    this.delete_from_source = transfer.delete_from_source;
    this.remark = transfer.remark;

    this.stations = transfer.stations;
    this.parameters = transfer.parameters;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      created_at: this.created_at,
      observation_id: this.observation_id,
      parameter_id: this.parameter_id,
      source_table: this.source_table,
      destination_table: this.destination_table,
      status: this.status,
      date_from: this.date_from,
      date_to: this.date_to,
      date_reached: this.date_reached,
      filter_duplicate: this.filter_duplicate,
      delete_from_source: this.delete_from_source,
      remark: this.remark,

      stations: this.stations,
      parameters: this.parameters,
    };
  }

  // deprecated: use updateFromJson
  updateFieldFromJson(field, json) {
    const items = this[field];
    if (field && this[field]) {
      this[field].push(json);
    }
  }

  updateFromJson(json, field) {
    // if field is specified, update only that field and return. Unstable
    if (field) {
      if (this[field].replace) {
        this[field].replace(json || []);
        return;
      }

      this[field] = json || [];
      return;
    }

    if (!!json.id) this.id = +json.id;
    if (!!json.created_at) this.created_at = json.created_at;
    if (!!json.source_table) this.source_table = json.source_table;
    if (!!json.destination_table) this.destination_table = json.destination_table;
    if (!!json.date_from) this.date_from = json.date_from;
    if (!!json.date_to) this.date_to = json.date_to;
    if (!!json.date_reached) this.date_reached = json.date_reached;

    this.status = json.status;
    this.filter_duplicate = json.filter_duplicate;
    this.delete_from_source = json.delete_from_source;
    this.remark = json.remark;

    this.stations = json.stations || this.stations;
    this.parameters = json.parameters || this.parameters;
  }
}



// WEBPACK FOOTER //
// ./src/models/TransferModel.js